<script setup>
import TokenGenerator from "@/components/TokenGenerator.vue";
</script>

<template>
  <div class="container mt-5">
    <TokenGenerator />
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>

<style scoped>
</style>

